export default {
    prevText: 'Föreg',
    nextText: 'Nästa',
};
